export const BC_SERVICES_CARD_LINK = 'https://gov.bc.ca/bcservicescard';
export const HEALTH_CAREERS_LINK = 'https://gov.bc.ca/careersinhealth';
export const HEALTH_CARE_ASSISTANT_LINK =
  'https://www2.gov.bc.ca/gov/content?id=BE923EC2608540C4A266F94C76461B1A';
// TODO: populate correct link when it becomes available
export const MENTAL_HEALTH_AND_ADDICTIONS_WORKER_LINK =
  'https://www2.gov.bc.ca/gov/content?id=A96A1E01C54141F2B4A289482793E5FD';

// Gov laws
export const BC_LAWS_LINK =
  'https://www.bclaws.ca/civix/document/id/complete/statreg/96165_03#section26';
export const INTERIOR_GOV_LINK =
  'https://www2.gov.bc.ca/assets/gov/data/geographic/land-use/administrative-boundaries/health-boundaries/1_interior_health_authority.pdf';
export const FRASER_GOV_LINK =
  'https://www2.gov.bc.ca/assets/gov/data/geographic/land-use/administrative-boundaries/health-boundaries/2_fraser_health_authority.pdf';
export const VANCOUVER_COASTAL_GOV_LINK =
  'https://www2.gov.bc.ca/assets/gov/data/geographic/land-use/administrative-boundaries/health-boundaries/3_vancouver_coastal_health_authority.pdf';
export const VANCOUVER_ISLAND_GOV_LINK =
  'https://www2.gov.bc.ca/assets/gov/data/geographic/land-use/administrative-boundaries/health-boundaries/4_vancouver_island_health_authority.pdf';
export const NORTHERN_GOV_LINK =
  'https://www2.gov.bc.ca/assets/gov/data/geographic/land-use/administrative-boundaries/health-boundaries/5_northern_health_authority.pdf';

// Employer Login
export const HCAP_LINK =
  'https://www2.gov.bc.ca/gov/content/employment-business/job-seekers-employees/find-a-job/health-care';
export const PEOI_LINK = 'https://hcapparticipants.gov.bc.ca/';

// Footer
export const HOME_LINK = 'https://hcapemployers.gov.bc.ca/';
export const ABOUT_GOV_BC_LINK = 'https://www2.gov.bc.ca/gov/content/about-gov-bc-ca';
export const DISCLAIMER_LINK = 'https://www2.gov.bc.ca/gov/content/home/disclaimer';
export const PRIVACY_LINK = 'https://www2.gov.bc.ca/gov/content/home/privacy';
export const ACCESSABILITY_LINK = 'https://www2.gov.bc.ca/gov/content/home/accessible-government';
export const COPYRIGHT_LINK = 'https://www2.gov.bc.ca/gov/content/home/copyright';

// email
export const HCAP_INFO_EMAIL = 'HCAPInfoQuery@gov.bc.ca';
